import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, tap } from 'rxjs';
import { IGenericResponse } from '../interfaces';
import { LoadingService } from '../loading/services/loading.service';
import { finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

export interface ForkModel {
  url: string;
  payload?: any;
  type: string;
}

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(
    private httpClient: HttpClient,
    private loadingService: LoadingService,
    private translate: TranslateService
  ) {}

  openLink(link: any, type?: any) {
    window.open(link, type);
  }

  public serviceCall(method: 'post' | 'get' | 'delete', url: string, payload?: any): Observable<any> {
    this.loadingService.showLoading();
    payload = payload || {};
    switch(method){
      case 'post':
        return this.handleResponse(this.httpClient.post<IGenericResponse>(url, payload));
      case 'get':
        return this.handleResponse(this.httpClient.get<IGenericResponse>(url));
      case 'delete':
        return this.handleResponse(this.httpClient.delete<IGenericResponse>(url));
    }
  }

  public serviceCallExternal(method: 'post' | 'get', url: string, payload?: any): Observable<any> {
    payload = payload || {};
    if (method == 'post') {
      return this.handleResponse(this.httpClient.post<any>(url, payload));
    } else {
      return this.handleResponse(this.httpClient.get<any>(url));
    }
  }

  private handleResponse(resObs: Observable<IGenericResponse>): Observable<any> {
    return resObs.pipe(
      finalize(() => this.loadingService.hideLoading()),
      tap({
        next: (res: IGenericResponse) => {
          if (res) {
            if (res.IsSuccess === false) {
              // TODO : set error message of res
              // this.toastService.ShowToast('error', 'hata');
            } else {
              if (res.IsSuccess === undefined) {
                res['IsSuccess'] = true;
              }
            }
            return res;
          } else {
            return { IsSuccess: false };
          }
        },
        error: (error) => this.handleError(error),
      }),
    );
  }

  handleError(error: HttpErrorResponse) {
    if (error instanceof HttpErrorResponse) {
      console.error(error);
      switch ((<HttpErrorResponse>error).status) {
        case 500:
          // this.toastService.ShowToast('error', this.translate.instant('internal-server-error'))
          break;
        case 401:
          break;
        case 403:
          break;
      }
    }
  }
}
